import { render, staticRenderFns } from "./AssignLead.vue?vue&type=template&id=68650306&scoped=true&"
import script from "./AssignLead.vue?vue&type=script&lang=js&"
export * from "./AssignLead.vue?vue&type=script&lang=js&"
import style0 from "./AssignLead.vue?vue&type=style&index=0&id=68650306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68650306",
  null
  
)

export default component.exports